import { defineMessages } from '../define';

export const chats = defineMessages({
  en: {
    'chats.title': 'Chats',
    'chats.description': 'Every conversation your sessions can see.',
    'chats.searchPlaceholder': 'Search chats…',
    'chats.typeLabel': 'Chat type',
    'chats.type.any': 'Any type',
    'chats.unreadOnly': 'Unread only',
    'chats.captureNotice':
      'Capture is off by default. Turning it on lets Threadline open that conversation in the background to read new messages, and LINE will show it as read to the other party.',

    'chats.column.chat': 'Chat',
    'chats.column.session': 'Session',
    'chats.column.members': 'Members',
    'chats.column.messages': 'Messages',
    'chats.column.unread': 'Unread',
    'chats.column.lastMessage': 'Last message',
    'chats.column.capture': 'Capture',
    'chats.column.actions': 'Actions',

    'chats.pinned': 'Pinned',
    'chats.muted': 'Muted',
    'chats.pin': 'Pin to the top',
    'chats.unpin': 'Unpin',
    'chats.pin.name': 'Pin {name}',
    'chats.unpin.name': 'Unpin {name}',
    'chats.mute': 'Mute notifications',
    'chats.unmute': 'Unmute',
    'chats.mute.name': 'Mute {name}',
    'chats.unmute.name': 'Unmute {name}',
    'chats.capture.start': 'Capture {name}, marking it read in LINE',
    'chats.capture.stop': 'Stop capturing {name}',
    'chats.updateFailed': 'Could not update the chat',

    'chats.empty.title': 'No chats captured yet',
    'chats.empty.description': 'A chat appears here once a connected session sees activity in it.',
    'chats.empty.filtered.title': 'No chats match these filters',
    'chats.empty.filtered.description':
      'Try another session or clear the filters to see everything captured so far.',

    'chats.detail.chatFallback': 'Chat',
    'chats.detail.sessionFallback': 'Session',
    'chats.detail.membersUnknown': 'Members unknown',
    'chats.detail.members': '{count} members',

    'chats.detail.today': 'Today',
    'chats.detail.yesterday': 'Yesterday',
    'chats.detail.thisAccount': 'This account',

    'chats.detail.summarise': 'Summarise with AI',
    'chats.detail.summaryTitle': 'Conversation summary',
    'chats.detail.summaryFailed': 'Could not summarise this chat',
    'chats.detail.suggest': 'Suggest a reply',
    'chats.detail.suggestTitle': 'Suggested reply',
    'chats.detail.suggestFailed': 'Could not draft a reply',
    'chats.detail.useSuggestion': 'Put it in the composer',

    'chats.detail.exportReady': 'Export ready as {format}',
    'chats.detail.exportFailed': 'Could not build the export',

    'chats.detail.empty.title': 'Nothing captured in this chat yet',
    'chats.detail.empty.description': 'Messages appear as soon as the session sees activity here.',
    'chats.detail.loadEarlier': 'Load earlier messages',

    'chats.detail.composerPlaceholder': 'Write a reply…',
    'chats.detail.composerDisabled': 'Sending is unavailable',
    'chats.detail.send': 'Send',
    'chats.detail.sendSuccess': 'Message sent',
    'chats.detail.sendFailed': 'Could not send the message',
    'chats.detail.sendRefused': 'The browser session refused the message',

    'chats.detail.offline.before':
      'Replies go through the browser session, so it has to be connected.',
    'chats.detail.offline.link': 'Open the session',
    'chats.detail.offline.after': 'to reconnect it.',
  },
  th: {
    'chats.title': 'แชท',
    'chats.description': 'ทุกบทสนทนาที่เซสชันของคุณมองเห็น',
    'chats.searchPlaceholder': 'ค้นหาแชท…',
    'chats.typeLabel': 'ประเภทแชท',
    'chats.type.any': 'ทุกประเภท',
    'chats.unreadOnly': 'เฉพาะที่ยังไม่อ่าน',
    'chats.captureNotice':
      'การเก็บข้อมูลถูกปิดไว้เป็นค่าเริ่มต้น เมื่อเปิดใช้งาน Threadline จะเปิดบทสนทนานั้นเบื้องหลังเพื่ออ่านข้อความใหม่ และ LINE จะแสดงให้อีกฝ่ายเห็นว่าอ่านแล้ว',

    'chats.column.chat': 'แชท',
    'chats.column.session': 'เซสชัน',
    'chats.column.members': 'สมาชิก',
    'chats.column.messages': 'ข้อความ',
    'chats.column.unread': 'ยังไม่อ่าน',
    'chats.column.lastMessage': 'ข้อความล่าสุด',
    'chats.column.capture': 'เก็บข้อมูล',
    'chats.column.actions': 'การทำงาน',

    'chats.pinned': 'ปักหมุดไว้',
    'chats.muted': 'ปิดเสียงไว้',
    'chats.pin': 'ปักหมุดไว้ด้านบน',
    'chats.unpin': 'เลิกปักหมุด',
    'chats.pin.name': 'ปักหมุด {name}',
    'chats.unpin.name': 'เลิกปักหมุด {name}',
    'chats.mute': 'ปิดการแจ้งเตือน',
    'chats.unmute': 'เปิดการแจ้งเตือน',
    'chats.mute.name': 'ปิดการแจ้งเตือน {name}',
    'chats.unmute.name': 'เปิดการแจ้งเตือน {name}',
    'chats.capture.start': 'เก็บข้อมูล {name} และจะทำให้ LINE แสดงว่าอ่านแล้ว',
    'chats.capture.stop': 'หยุดเก็บข้อมูล {name}',
    'chats.updateFailed': 'ไม่สามารถอัปเดตแชทได้',

    'chats.empty.title': 'ยังไม่มีแชทที่เก็บไว้',
    'chats.empty.description': 'แชทจะปรากฏที่นี่เมื่อเซสชันที่เชื่อมต่ออยู่พบความเคลื่อนไหว',
    'chats.empty.filtered.title': 'ไม่มีแชทที่ตรงกับตัวกรองนี้',
    'chats.empty.filtered.description':
      'ลองเลือกเซสชันอื่นหรือล้างตัวกรองเพื่อดูทุกรายการที่เก็บไว้',

    'chats.detail.chatFallback': 'แชท',
    'chats.detail.sessionFallback': 'เซสชัน',
    'chats.detail.membersUnknown': 'ไม่ทราบจำนวนสมาชิก',
    'chats.detail.members': 'สมาชิก {count} คน',

    'chats.detail.today': 'วันนี้',
    'chats.detail.yesterday': 'เมื่อวาน',
    'chats.detail.thisAccount': 'บัญชีนี้',

    'chats.detail.summarise': 'สรุปด้วย AI',
    'chats.detail.summaryTitle': 'สรุปบทสนทนา',
    'chats.detail.summaryFailed': 'สรุปแชทนี้ไม่สำเร็จ',
    'chats.detail.suggest': 'ให้ AI ร่างคำตอบ',
    'chats.detail.suggestTitle': 'คำตอบที่แนะนำ',
    'chats.detail.suggestFailed': 'ร่างคำตอบไม่สำเร็จ',
    'chats.detail.useSuggestion': 'ใส่ในช่องพิมพ์ข้อความ',

    'chats.detail.exportReady': 'ไฟล์ส่งออกแบบ {format} พร้อมแล้ว',
    'chats.detail.exportFailed': 'สร้างไฟล์ส่งออกไม่สำเร็จ',

    'chats.detail.empty.title': 'ยังไม่มีข้อความที่เก็บไว้ในแชทนี้',
    'chats.detail.empty.description': 'ข้อความจะปรากฏทันทีที่เซสชันพบความเคลื่อนไหวในแชทนี้',
    'chats.detail.loadEarlier': 'โหลดข้อความก่อนหน้า',

    'chats.detail.composerPlaceholder': 'พิมพ์คำตอบ…',
    'chats.detail.composerDisabled': 'ยังส่งข้อความไม่ได้',
    'chats.detail.send': 'ส่ง',
    'chats.detail.sendSuccess': 'ส่งข้อความแล้ว',
    'chats.detail.sendFailed': 'ส่งข้อความไม่สำเร็จ',
    'chats.detail.sendRefused': 'เซสชันเบราว์เซอร์ปฏิเสธข้อความนี้',

    'chats.detail.offline.before': 'การตอบกลับต้องส่งผ่านเซสชันเบราว์เซอร์ จึงต้องเชื่อมต่ออยู่',
    'chats.detail.offline.link': 'เปิดหน้าเซสชัน',
    'chats.detail.offline.after': 'เพื่อเชื่อมต่อใหม่',
  },
});
